export function SubComponent() {

  return function (target: Function) {
    Object.defineProperty(target.prototype, "ionViewCanEnter", {
      value: checkIfNavHasParent
    });
  };

  function checkIfNavHasParent(): boolean {
    
    if (this.nav === undefined) {
      const errorMsg = "@SubComponent requires the target component to have the NavController injected as property 'nav'";
      throw new Error(errorMsg);
    }
    
    if(this.nav.parent === null){
      const errorMsg = "@SubComponent requires the target component\'s NavController to have a parent. " +
        "In other words: it cannot be set into the root NavController";
      throw new Error(errorMsg);      
    }
    
    return true;
  }

}


// WEBPACK FOOTER //
// ./src/decorators/subcomponent.ts